import React, { Component } from 'react'
import Header from '../header/Header';
import RecruitmentLanding from './recruitmentlanding/RecruitmentLanding';
import RecruitmentInfo from './recruitmentinfo/RecruitmentInfo';
import ApplicationInfo from './applicationinfo/ApplicationInfo';
import FaqInfo from "./faqinfo/faqinfo";
import Footer from '../footer/Footer';

import PhotoSlide from '../photoslide/PhotoSlide';

import './Recruitment.css'


import Button from '../button/Button.jsx';

export class Recruitment extends Component {
  componentDidMount() {
    window.scrollTo(0, 0)
    setTimeout(function() {
      document.getElementById("recruitment-top-showcase").style.opacity = 1;
      document.getElementById("recruitment-top-showcase-image").style.right = "50px";

      if(window.innerWidth>1400) {
        document.getElementById("recruitment-top-text").style.top = "300px";
      } else {
        document.getElementById("recruitment-top-text").style.top = "50vh";
      }

    },500);
  }

  render() {

    return (
      <div className="recruitment-page-container">
        <Header />
        <RecruitmentLanding />
        <RecruitmentInfo />
        <ApplicationInfo />
        <FaqInfo />
        <Footer />
      </div>
    )
  }
}

export default Recruitment
